(() => {
  const dialog = document.getElementById('GutBarrierLaunchPopup');
  if (!dialog || typeof dialog.showModal !== 'function' || window.Shopify?.designMode) return;

  const close = () => dialog.close();
  dialog.querySelector('.gb-launch-popup__close').addEventListener('click', close);
  dialog.querySelector('.gb-launch-popup__dismiss').addEventListener('click', close);
  dialog.addEventListener('click', (event) => {
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right ||
        event.clientY < bounds.top || event.clientY > bounds.bottom) close();
  });
  dialog.addEventListener('close', () => document.documentElement.classList.remove('gb-launch-popup-open'));
  dialog.querySelector('.gb-launch-popup__cta').addEventListener('click', close);

  window.setTimeout(() => {
    if (document.querySelector('dialog[open], .popup-open, .menu-opening')) return;
    dialog.showModal();
    document.documentElement.classList.add('gb-launch-popup-open');
  }, 2500);
})();
